import { FormikValues } from 'formik';
import { navigate } from 'gatsby';
import queryString from 'query-string';

export const formNavigate = async (values: FormikValues) => {
  await navigate(
    `?${queryString.stringify(values, {
      skipNull: true,
      skipEmptyString: true,
      arrayFormat: 'comma',
    })}`,
    {
      state: {
        scroll: false,
      },
    },
  );
};
